import React, { useState, useRef } from "react";

const ZoomableImage = ({ 
  src, 
  zoom = 3,
  previewWidth = 350, // Increased to match your screenshot size
  previewHeight = 350,
  zoomedWidth = 500, // Larger zoomed image
  zoomedHeight = 500
}) => {
  const [zoomed, setZoomed] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!imgRef.current) return;
    
    const rect = imgRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    setMousePosition({ x, y });
  };

  const handleMouseEnter = () => setZoomed(true);
  const handleMouseLeave = () => setZoomed(false);

  return (
    <div style={{ 
      display: "inline-block", // Changed to inline-block to remove extra space
      position: "relative",
      verticalAlign: "top" // Aligns properly with text content
    }}>
      {/* Original Preview Image */}
      <div style={{ position: "relative", display: "inline-block" }}>
        <img
          ref={imgRef}
          src={src}
          alt="zoomable"
          style={{
            width: `${previewWidth}px`,
            height: `${previewHeight}px`,
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            cursor: zoomed ? "zoom-out" : "zoom-in",
            transition: "transform 0.3s ease",
            display: "block", // Removes extra space below image
          }}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onMouseMove={handleMouseMove}
        />

        {/* Zoom Lens Overlay */}
        {zoomed && (
          <div
            style={{
              position: "absolute",
              top: mousePosition.y - 75, // Adjusted for larger image
              left: mousePosition.x - 75,
              width: "150px",
              height: "150px",
              border: "2px solid #fff",
              borderRadius: "8px",
              background: "rgba(0,0,0,0.15)",
              pointerEvents: "none",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              transition: "opacity 0.2s ease",
            }}
          />
        )}
      </div>

      {/* Zoomed Image - Appears on hover */}
      {zoomed && imgRef.current && (
        <div
          style={{
            position: "absolute",
            top: "0",
            left: `${previewWidth + 20}px`, // Reduced gap from original
            width: `${zoomedWidth}px`,
            height: `${zoomedHeight}px`,
            border: "1px solid #ddd",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            backgroundImage: `url(${src})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: `${imgRef.current.offsetWidth * zoom}px ${
              imgRef.current.offsetHeight * zoom
            }px`,
            backgroundPosition: `-${mousePosition.x * zoom - previewWidth / 2}px -${
              mousePosition.y * zoom - previewHeight / 2
            }px`,
            transition: "opacity 0.25s ease",
            zIndex: 1000,
            backgroundColor: "white",
          }}
        />
      )}
    </div>
  );
};

export default ZoomableImage;